// @flow
import React from 'react';

import { FormattedMessage } from 'react-intl';
import styles from './changeStopCardContent.css';


type ChangeStopCardContentPropTypes = {
  requestedByFirstName: string,
  requestedByLastName: string,
  description?: string
};

const ChangeStopCardContent = ({
  requestedByFirstName,
  requestedByLastName,
  description,
}: ChangeStopCardContentPropTypes) => (
  <div
    className={
      `
        ${styles.changeStopCardContent}
      `
    }
  >
    <p className={styles.commentedBy}>
      <FormattedMessage
        defaultMessage=""
        id="changeStopRequests.commented"
        values={{
          user:
  <span className={styles.darkerTitle}>
    {requestedByFirstName}
    {' '}
    {requestedByLastName}
  </span>,
        }}
      />
    </p>
    <p className={styles.description}>
      {description}
    </p>
  </div>
);


export default ChangeStopCardContent;



// WEBPACK FOOTER //
// ./src/scripts/components/ChangeStopRequestCard/ChangeStopCardContent/index.jsx